import React, { useEffect } from 'react'

function usePreventZoom(scrollCheck = true, keyboardCheck = true, onchangeScroll, playbackLength) {
  useEffect(() => {

    const handleWheel = (e) => {
      if (scrollCheck && e.ctrlKey) {
        e.preventDefault();
        onchangeScroll(e);
      }
    };

    document.addEventListener("wheel", handleWheel, { capture: true, passive: false });

    return () => {
      document.removeEventListener("wheel", handleWheel, { capture: true, passive: false });
    };
  }, [scrollCheck, keyboardCheck, playbackLength]);
}

export default usePreventZoom